import { Button } from "@blueprintjs/core"
import { useMemo, useState } from "react"
import { DIALOG_SIZE } from "src/libs/interfaces/layouts"
import IScalarForm from "src/libs/scalars/interface/IScalarForm"
import Scalar from "src/libs/scalars/scalars/Scalar"
import { ScalableDialog } from "src/libs/useful"
import { __, jsonToData, sprintf } from "src/libs/utilities"

/* Protopia Ecosystem component */
const TestResultScalarWidget = (props: IScalarForm): JSX.Element => {
    
    // console.log(props.origin)
    
    return <Scalar 
        { ...props } 
        notClear
        enabledForm={<TestResultScalarEnable {...props} />}
        desabledForm={<TestResultScalarEnable {...props} />}
    />
}
const TestResultScalarEnable = (props: IScalarForm): JSX.Element => {
    const [isOpen, setIsOpen] = useState<boolean>(false) 
        const results = useMemo(() => jsonToData(props.value || "[]"), [])   
        
        const onOpen = () => {
            setIsOpen(!isOpen)
        }
        return <div className='pe-test-result-tread-widget-container'>
           <Button variant="outlined" size="small" className="descr" onClick={onOpen}>
                {sprintf( __("Show all %s results"), results.length.toString() )}
            </Button>
            <ScalableDialog
                dialogSize={DIALOG_SIZE.NORMAL}
                isOpen={isOpen}
                onClose={onOpen}
                hideClose={false}
                mayFullScreen
            >
                <div className="p-5 max-height flex-column overflow-y-auto">
                    <div className="container">
                    {
                        results?.map((r: any, i: number) => {
                            return <div className="px-3 py-1 row" key={i}>
                                <div className="col-9 descr text-force-contrast "  >
                                    {  r.answer_id }
                                </div> 
                                <div className="col-3">
                                    {  r.value }
                                </div>
                            </div>
                        })
                    }
                    </div>
                </div>
           </ScalableDialog>
        </div>
}
export default TestResultScalarWidget


const VisualResult = (value: any, origin:any) => {

}